import * as Restaumatic$dSite$dComponents$dCart$dControl from "../Restaumatic.Site.Components.Cart.Control/index.js";
import * as Restaumatic$dSite$dComponents$dCart$dView from "../Restaumatic.Site.Components.Cart.View/index.js";
import * as Specular$dInternal$dRIO from "../Specular.Internal.RIO/index.js";
const cartModalWidget = config => Specular$dInternal$dRIO.bindImpl(Restaumatic$dSite$dComponents$dCart$dControl.control(config))(v => {
  const $0 = v._2;
  return Specular$dInternal$dRIO.bindImpl(Restaumatic$dSite$dComponents$dCart$dView.view(config)(v._1))(() => Specular$dInternal$dRIO.pureImpl($0));
});
export {cartModalWidget};
